<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <div>
          <label class="title">周期完成情况统计</label>
          <slot name="periodItemId"></slot>
          <label style="margin-right: 20px;margin-left: 20px">研究中心：{{centerName}}</label>
          <a-button @click="viewCenter" type="primary" icon="plus">查看全部中心</a-button>

        </div>
        <a-row style="margin-top: 10px">
          <a-col :span="8">
            通过筛选时间：<a-range-picker v-model="registerDateRange" value-format="YYYY-MM-DD" @change="dateChange" :ranges="{ '本日': [moment(), moment()], '本周': [moment().startOf('week'), moment().endOf('week')],'本月': [moment().startOf('month'), moment().endOf('month')]  }"/>
          </a-col>
          <a-col :span="6">
            表单：<a-input v-model="queryParam.formName" style="width: 200px"></a-input>
          </a-col>
          <a-col :span="6">
            <a-button @click="searchQuery" type="primary" icon="search">查询</a-button>
            <a-button @click="searchReset" type="primary" icon="reload" style="margin-left: 10px">重置</a-button>
            <a-button @click="downloadHandle" type="primary" icon="download" style="margin-left: 10px">下载</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div style="margin-top: 5px;margin-bottom: 5px">

    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"

        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        @change="handleTableChange">

        <span slot="normalsubmitAllTitle" style="color: red">
          正常提交
        </span>
        <span slot="normalsubmitTitle" style="color: red">
          提交总数
        </span>
        <span slot="overduesubmitAllTitle" style="color: red">
          过期提交
        </span>
        <span slot="overduesubmitTitle" style="color: red">
          提交总数
        </span>
        <span slot="normalsubmit" slot-scope="text, record">
          {{text}}
          <br/>
          (
          <label style="color: green;">{{record.normalsubmitrate}}</label>
          )
        </span>
        <span slot="fullsubmit" slot-scope="text, record">
          {{text}}
                  <br/>
       (
          <label style="color: green;">{{record.fullsubmitrate}}</label>
          )
        </span>
        <span slot="overduesubmit" slot-scope="text, record">
          {{text}}
                  <br/>
        (
          <label style="color: green;">{{record.overduesubmitrate}}</label>
          )
        </span>
        <span slot="overduefullsubmit" slot-scope="text, record">
          {{text}}
                 <br/>
           (
          <label style="color: green;">{{record.overduefullsubmitrate}}</label>
          )
        </span>
      </a-table>
    </div>

  </a-card>
</template>

<script>
  import moment from 'moment';
  import {putAction,getFileAccessHttpUrl,downloadFile} from '@/api/manage';
  import {frozenBatch} from '@/api/api'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import { getAction,postAction } from '@/api/manage'

  import Vue from 'vue'
  export default {
    name: "Info",
    mixins: [JeecgListMixin],
    components: {

    },
    props:['centerId','periodItemId'],
    data() {
      return {
        formName:'',
        registerDateRange:[],
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        queryParam: {},
        centerName:'',
        periodItemList:[],
        columns: [
          {
            title: '表单',
            align: "center",
            dataIndex: 'formname',
            width: 120,
          },
          {
            title: '入组人数',
            align: "center",
            dataIndex: 'patientnum',
            width: 120,
            customRender: (value, row, index) => {
              const lastrow = index===0?{}:this.dataSource[index-1]
              const obj = {
                children: value,
                attrs: {},
              };
              if (lastrow.patientnum === row.patientnum) {
                obj.attrs.rowSpan = 0;
              }else{
                let rowSpan = 1;
                let end = false
                this.dataSource.forEach((baserow,baseIndex)=>{
                  if(baseIndex>index && !end){
                    if (baserow.patientnum === row.patientnum) {
                      rowSpan++;
                    }else{
                      end = true
                    }
                  }
                })
                // console.log('rowSpan',rowSpan,index,value)
                obj.attrs.rowSpan = rowSpan;
              }
              return obj;
            },
          },
          {
            // title: '正常提交',
            align: "center",
            slots: { title: 'normalsubmitAllTitle' },
            children:[
              {
                // title: '提交总数',
                slots: { title: 'normalsubmitTitle' },
                align: "center",
                width: 100,
                dataIndex: 'normalsubmit',
                scopedSlots: { customRender: 'normalsubmit' },
              },
              {
                title: '完整提交',
                align: "center",
                width: 100,
                dataIndex: 'fullsubmit',
                scopedSlots: { customRender: 'fullsubmit' },
              },
              {
                title: '数据缺失',
                align: "center",
                width: 100,
                dataIndex: 'misssubmit',
              },
            ],
          },
          {
            // title: '过期提交',
            align: "center",
            slots: { title: 'overduesubmitAllTitle' },
            children:[
              {
                // title: '提交总数',
                align: "center",
                width: 100,
                dataIndex: 'overduesubmit',
                slots: { title: 'overduesubmitTitle' },
                scopedSlots: { customRender: 'overduesubmit' },
              },
              {
                title: '完整提交',
                align: "center",
                width: 100,
                dataIndex: 'overduefullsubmit',
                scopedSlots: { customRender: 'overduefullsubmit' },
              },
              {
                title: '数据缺失',
                align: "center",
                width: 100,
                dataIndex: 'overduemisssubmit',
              },
            ],
          },
          {
            title: '失访提交',
            align: "center",
            dataIndex: 'lostsubmit',
            width: 120,
          },
          {
            title: '暂存',
            align: "center",
            dataIndex: 'tempsubmit',
            width: 120,
          },
          {
            title: '未开始',
            align: "center",
            dataIndex: 'nosubmit',
            width: 120,
          },
          {
            title: '正常提交率',
            align: "center",
            dataIndex: 'allsubmitrate',
            width: 120,
          },
          {
            title: '完整提交率',
            align: "center",
            dataIndex: 'allfullsubmitrate',
            width: 120,
          },
          {
            title: '操作',
            align: "center",
            dataIndex: 'action',
            width: 120,
            customRender: (value, row, index) => {
              const child = this.$createElement('a', {
                domProps: {
                  innerHTML: '查看明细'
                },
                on: {
                  click: ()=> {
                    this.viewItem(row)
                  }
                }
              })
              const obj = {
                children: child,
                attrs: {},
              };
              if (index > 0) {
                obj.attrs.rowSpan = 0;
              }else{
                obj.attrs.rowSpan = this.dataSource.length
              }
              return obj;
            },
          },
        ],
        url: {
          list: "/project/statistic/baseLine/item",
        },
        disableMixinCreated:true,
      }
    },
    computed: {

    },
    mounted(){
      this.baseQueryParam = {
        centerId : this.centerId,
        projectId : this.projectId,
        periodItemId : this.periodItemId,
      }
      this.loadCenterName()
      this.loadData()
    },
    watch:{
      centerId(){
        this.queryParam.centerId = this.centerId
        this.baseQueryParam.centerId = this.centerId
        this.loadCenterName()
        this.loadData()
      },
      periodItemId(){
        // console.log("periodItemId:"+ this.periodItemId)
        this.queryParam.periodItemId = this.periodItemId
        this.baseQueryParam.periodItemId = this.periodItemId
        this.loadData()
      }
    },
    methods: {
      moment,
      periodItemIdChange(){
        this.$emit('periodItemIdChange',this.queryParam.periodItemId)
        this.loadData()
      },
      viewItem(row){
        // 查看基线的表单
        this.$emit('typeChange','3')
      },
      viewCenter(){
        this.$emit('typeChange','2')
      },
      dateChange(){
        if(this.registerDateRange.length===0){
          this.queryParam.startDate = ''
          this.queryParam.endDate = ''
        }else {
          this.queryParam.startDate = this.registerDateRange[0]
          this.queryParam.endDate = this.registerDateRange[1]
        }
        this.loadData()
      },
      loadCenterName(){
        getAction('/management/center/queryById',{id:this.centerId}).then(res=>{
          if(res.success){
            this.centerName = res.result.name
          }
        })
      },
      downloadHandle(){
        const params = Object.assign({},this.queryParam,this.baseQueryParam)
        downloadFile('/project/statistic/baseLine/itemExport','周期完成情况.xlsx',params)
      }
    }
  }
</script>
<style scoped lang="less">
  .title{
    font-size: 20px;
    font-weight: bold;
    color: @primary-color;
    margin-right: 30px;
  }
</style>
